import ConfigureCompanyInviteImage from '@/assets/img/configure-company-invite.svg';
import ModalDefault, {
  IModalDefaultProps,
} from '@/components/Modals/ModalDefault';

const ConfigureCompanyInviteModal = (props: IModalDefaultProps) => {
  return (
    <ModalDefault
      {...props}
      src={ConfigureCompanyInviteImage}
      alt="Imagem representando convite para configurar a empresa."
      title="Vamos configurar sua empresa?"
      subtitle="Para continuar, precisamos de alguns detalhes de atuação de sua empresa."
      textButton="CONFIGURAR EMPRESA"
    />
  );
};

export default ConfigureCompanyInviteModal;
